import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const CancelPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/users/`, { credentials: 'include' });
        if (response.ok) {
          // User is authenticated, redirect to businesses page
          navigate('/businesses', { replace: true });
        } else {
          // User is not authenticated, redirect to landing page
          navigate('/', { replace: true });
        }
      } catch (error) {
        // On error, assume not authenticated and redirect to landing
        navigate('/', { replace: true });
      }
    };
    checkAuth();
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        background: 'linear-gradient(135deg, #f8f9fe 0%, #ffffff 100%)',
      }}
    >
      <CircularProgress size={60} thickness={4} sx={{ mb: 4 }} />
      <Typography variant="h5" align="center" gutterBottom>
        Checkout Cancelled
      </Typography>
      <Typography variant="body1" align="center" color="textSecondary" sx={{ mb: 4 }}>
        Redirecting you back...
      </Typography>
    </Box>
  );
};

export default CancelPage; 